require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./los-tifos-mas-espectaculares-en-la-historia-de-la-champions-league.json") })
        }
      }, "path---los-tifos-mas-espectaculares-en-la-historia-de-la-champions-league");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---los-tifos-mas-espectaculares-en-la-historia-de-la-champions-league!./.cache/json/los-tifos-mas-espectaculares-en-la-historia-de-la-champions-league.json
// module id = 454
// module chunks = 231608221292675